import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFeather: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFeather"><Path d="M5.58125 18.9165C5.52646 19.6882 5.5 20.4678 5.5 21.25V22H4V21.25C4 16.5462 4.91866 11.7578 7.29395 8.12112C9.69806 4.44034 13.5592 2 19.25 2H20V2.75C20 5.0837 18.6857 7.05801 17.4752 8.39274C16.8829 9.04584 16.2925 9.57114 15.8399 9.94033L17.5342 11.2013C17.4446 11.4906 17.3626 11.7759 17.2486 12.056C17.1652 12.2606 17.0377 12.5458 16.8558 12.8847C16.4924 13.5617 15.9088 14.4584 15.0217 15.3541C13.2425 17.1507 10.2864 18.8966 5.58125 18.9165Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFeather;
